/**
 * Status-driven presentation for criterion cards.
 */

const DEFAULT_FINDING_CONTAINER_CLASSES = "border-[#C5DBFF] bg-[#F3F8FF]";
const DEFAULT_FINDING_LABEL_CLASS = "text-[#0056D6]";
const DATA_MISSING_FINDING_CONTAINER_CLASSES =
    "border-[#FB8C00] bg-[#FFF3E0]";
const DATA_MISSING_FINDING_LABEL_CLASS = "text-[#C24400]";
const DATA_MISSING_LEFT_BORDER_COLOR = "#E65100";
const DATA_MISSING_LEFT_BORDER_WIDTH = 3;

/** Visual values consumed by a criterion card. */
export interface CriteriaCardStatusStyles {
    leftBorderColor?: string;
    leftBorderWidth?: number;
    findingContainerClasses: string;
    findingLabelClass: string;
}

/**
 * Resolve criterion-card presentation for an atom screening status.
 *
 * @param screeningStatus - Atom screening status
 * @param leftBorderColor - Caller-provided border color for ordinary statuses
 * @param leftBorderWidth - Caller-provided border width for ordinary statuses
 * @returns Status-specific border and Findings panel presentation
 */
export function getCriteriaCardStatusStyles(
    screeningStatus: string | undefined,
    leftBorderColor: string | undefined,
    leftBorderWidth: number | undefined,
): CriteriaCardStatusStyles {
    if (screeningStatus === "DATA_MISSING") {
        return {
            leftBorderColor: DATA_MISSING_LEFT_BORDER_COLOR,
            leftBorderWidth: DATA_MISSING_LEFT_BORDER_WIDTH,
            findingContainerClasses: DATA_MISSING_FINDING_CONTAINER_CLASSES,
            findingLabelClass: DATA_MISSING_FINDING_LABEL_CLASS,
        };
    }

    return {
        leftBorderColor,
        leftBorderWidth,
        findingContainerClasses: DEFAULT_FINDING_CONTAINER_CLASSES,
        findingLabelClass: DEFAULT_FINDING_LABEL_CLASS,
    };
}
